import React from "react";
import logo from "assets/img/logo/logo_aig_login-2.png";
import LoadingScreen from "react-loading-screen";

import Cotizacion from "../../components/CotizacionFinanciero/CotizacionFinanciero";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { fetchDataFinanciero,fetchConsultarCarritoFinanciero,fetchListarCotizadores,fetchGirosNegocioFinanciero, fetchGirosNegocioFinanciero2 } from "../../redux/actions/aRamoLineaFinanciera";
import {encriptarTramaAES} from "../../utils/Encriptar/index";
import { ambienteAplicacion } from '../../constants/urls';
import {sucursalesFetch } from "../../redux/actions/aRamos";


class ContainerCotizacionFinanciero extends React.Component {
  constructor(props) {
    super(props);
    this.state={
      cargando:true
    }
  }
  async componentDidMount() {    
    // url search params
    const queryParams = new URLSearchParams(this.props.location.search)
    
    if(queryParams.get('idProducto') !== null){
        if( queryParams.get('preservar') === 'no' || queryParams.get('preservar') === null ){
          await this.props.listarDatos(queryParams.get('idProducto'))
          await this.props.consultarCarrito('')
        }          
        await this.props.listarCotizadores(ambienteAplicacion);
    }
    else if(queryParams.get('id') !== null){
      /*Consulta Carrito*/  
        const datosJSON = {
            idCarrito: queryParams.get('id')
          }
      const encriptado = await encriptarTramaAES(JSON.stringify(datosJSON));
      await this.props.consultarCarrito(Buffer.from(JSON.stringify(encriptado)).toString('base64'));  
      await this.props.listarDatos(this.props.detalleCarrito.datosCarritoFinanciero.carSeguro);
    }
    await this.props.fethSucursales();
    //await this.props.listarGirosNegocio();
    await this.props.listarGirosNegocio2(queryParams.get('idProducto'));
    this.setState({
      cargando:false
    })

  }

  render() {
    const {detalleCarrito, listarDatosF, datosListarCotizadores,listaGirosNegocio,listaSucursales}= this.props;
    const {cargando}= this.state;
    /* Se obtiene el nombre del cotizador*/
    const queryParams = new URLSearchParams(this.props.location.search);
    let nombreCotizador = "";
    if(Object.keys(detalleCarrito.datosCarritoFinanciero).length>0){
      nombreCotizador = detalleCarrito.datosCarritoFinanciero.carDescripcionSeguro;
    }else if(Object.keys(datosListarCotizadores.listarCotizadores).length>0){
      let elemento = datosListarCotizadores.listarCotizadores.find(element => element.segCodigoCore === parseInt(queryParams.get('idProducto') , 10 ));
      if(elemento !== undefined){
          nombreCotizador = elemento.segNombre;
      }
    }

    return (
      <main className="bg-light">
        <div className="cr-content container-fluid">
          <div className="container-body-spaces">
          <LoadingScreen
              loading={cargando || detalleCarrito.consultarCarritoFinancieroIsLoading || listarDatosF.FinancieroisLoading || datosListarCotizadores.listarCotizadoresIsLoading}
              bgColor="#f1f1f1"
              spinnerColor="#001871"
              textColor="#676767"
              logoSrc={logo}
              text="Cargando datos..."
            >
            {!cargando  &&
            <Cotizacion detalleCarrito={detalleCarrito.datosCarritoFinanciero} listarIngresos={listarDatosF.listarIngresos} listarProvincias ={listarDatosF.listarProvincias} 
            Cotizador ={nombreCotizador} listaGirosNegocio={listaGirosNegocio.datosGirosNegocio} listaSucursales={listaSucursales}
            preservar={new URLSearchParams(this.props.location.search).get('preservar')}/>
            }
            </LoadingScreen>
          </div>
        </div>
      </main>
    );

  }
}

const mapStateToProps = state => ({
  detalleCarrito : state.datosCarritoFinanciero,
  listarDatosF : state.dataFinanciero,
  datosListarCotizadores : state.datosListarCotizadores,
  listaGirosNegocio :state.girosNegocioFinanciero,
  listaSucursales: state.datosSucursales.DataSucursales,

});

const mapDispatchToProps = dispatch => {
  return {
    listarDatos: (codProducto) => dispatch(fetchDataFinanciero(codProducto)),
    consultarCarrito: (data) => dispatch(fetchConsultarCarritoFinanciero(data)),
    listarCotizadores: (datos) => dispatch(fetchListarCotizadores(datos)),
    listarGirosNegocio: () => dispatch(fetchGirosNegocioFinanciero()),
    listarGirosNegocio2: (prod) => dispatch(fetchGirosNegocioFinanciero2(prod)),
    fethSucursales: () => dispatch(sucursalesFetch()),

  };
};

  export default withRouter(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(ContainerCotizacionFinanciero)
  );